/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getTrends.defs'
export { main as default } from './getTrends.defs'
